module.exports = __webpack_public_path__ + "img/logo.781da141.jpg";